// extracted by mini-css-extract-plugin
export default {"label":"label_label__Z7qUG","lightLabel":"label_lightLabel__Ytto5"};